import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ish-header-checkout',
  templateUrl: './header-checkout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderCheckoutComponent {}
